/**
 * Route for `click-spam-detection`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ClickSpamDetectionPage } from "../features/click-spam-detection/ClickSpamDetectionPage";

export const clickSpamDetectionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/click-spam-detection",
	component: ClickSpamDetectionPage,
});

export default clickSpamDetectionRoute;
